export default __webpack_public_path__ + "static/media/Megha-Shrestha.cf59aed7.jpg";